const PostGrid = (element) => {
  const categoryButtons = document.querySelectorAll("[data-filtercategory]");
  const postCards = document.querySelectorAll("[data-category]");
  
  const search = document.querySelector("#post-grid-search");
  const magnifyingGlass = document.querySelector("#search-icon");

  const searchTextElement = document.querySelector("#post-grid-term");
  const empty = document.querySelector("#post-grid-empty");
  const clearButton = document.querySelector("#post-filters-clear");
  const loadMoreButton = document.querySelector("#post-grid-paginate");

  let activeCategory = null;
  let currentVisibleIndex = 6;

  const filterPosts = () => {
    const searchTerm = search.value.toLowerCase();
    
    searchTextElement.textContent = searchTerm;

    let visiblePosts = 0;

    postCards.forEach((postCard, index) => {
      const postCategory = postCard.getAttribute("data-category");
      const postTitle = postCard.querySelector(".articleCard__heading").textContent.toLowerCase();

      const matchesCategory = !activeCategory || activeCategory === 'all' || postCategory === activeCategory;
      const matchesSearch = !searchTerm || postTitle.includes(searchTerm);

      if (matchesCategory && matchesSearch) {
        postCard.style.display = "block";
        visiblePosts++;

        if (visiblePosts <= currentVisibleIndex) {
          postCard.classList.remove("hidden");
        } else {
          postCard.classList.add("hidden");
        }
      } else {
        postCard.style.display = "none";
        postCard.classList.add("hidden");
      }
    });

    if (visiblePosts === 0) {
      empty.classList.remove("hidden");
    } else {
      empty.classList.add("hidden");
    }

    if (visiblePosts <= currentVisibleIndex) {
      loadMoreButton.classList.add("hidden");
    } else {
      loadMoreButton.classList.remove("hidden");
    }
  };

  const loadMorePosts = () => {
    currentVisibleIndex += 3;
    filterPosts();
  };

  const addClickListeners = () => {
    if (categoryButtons.length > 0) {
      categoryButtons.forEach((button) => {
        button.addEventListener("click", () => {
          categoryButtons.forEach(btn => btn.classList.remove("active"));
          button.classList.add("active");
          activeCategory = button.getAttribute("data-filtercategory");
          
          currentVisibleIndex = 6;
          filterPosts();
        });
      });
    }

    if (clearButton) {
      clearButton.addEventListener("click", () => {
        activeCategory = null;
        search.value = "";
        currentVisibleIndex = 6;

        categoryButtons.forEach((button, index) => {
          if (index === 0) {
            button.classList.add("active");
          } else {
            button.classList.remove("active");
          }
        });

        filterPosts();
      });
    }

    if (loadMoreButton) {
      loadMoreButton.addEventListener("click", loadMorePosts);
    }
  };

  const addChangeListeners = () => {
    if (search) {
      search.addEventListener("input", () => {
        currentVisibleIndex = 6;
        filterPosts();
      });

      // if (magnifyingGlass) {
      //   search.addEventListener("focus", () => {
      //     console.log("here");
      //     magnifyingGlass.classList.add("focused");
      //   });
        
      //   search.addEventListener("blur", () => {
      //     magnifyingGlass.classList.add("focused");
      //   });
      // }
    }
  };

  const initHiddenPosts = () => {
    postCards.forEach((postCard, index) => {
      if (index >= currentVisibleIndex) {
        postCard.classList.add("hidden");
      }
    });
  };

  const main = () => {
    initHiddenPosts();
    addClickListeners();
    addChangeListeners();
    filterPosts();
  };

  main();
};

export default PostGrid;
